'use client';

export { default } from './DialogContentText';
export { default as dialogContentTextClasses } from './dialogContentTextClasses';
export * from './dialogContentTextClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/DialogContentText/index.js
// module id = 844
// module chunks = 22